import { Component } from '@angular/core';

@Component({
    selector: 'gl-schedule-search-page',
    templateUrl: './schedule-search-page.component.html',
    styleUrls: ['./schedule-search-page.component.scss']
})
export class ScheduleSearchPageComponent {}
